<template>
  <div class="step-wrap" :class="{ iframeFontLarge: isInPassport }">
    <div>
      <van-form
        class="form work-temp-form"
        ref="formRef"
        @submit="beforeSubmit"
      >
        <p class="mb-20" v-if="submitForm.isUs">
          Within the past month, there has been unusual activity on this
          account, such as a login from an unfamiliar IP address or a password
          change/reset. Therefore, we ask that you complete additional
          verification steps to confirm that your request is authentic and that
          you are the rightful owner of the account.
        </p>
        <p class="mb-20" v-else>{{ languages.pleaseFillIn }}</p>
        <component
          :is="compType[item.isCustomComp ? item.type : item.formType]"
          v-for="item in formList"
          :key="item.id"
          :id="item.id"
          :type="item.type"
          :formData="formData"
          :labelInfo="item.labelInfo"
          :customKey="item.customKey"
          :gameId="gameId"
          :required="item.required"
          :label="item.label"
          :compKey="item.id"
        ></component>
        <div class="form-item-submit mb-60">
          <van-button class="btn" block type="info" native-type="submit">
            <template>{{ languages.submit }}</template>
          </van-button>
        </div>
      </van-form>
    </div>
    <van-dialog
      v-model="showTip"
      :title="languages.formCompleted"
      width="90%"
      :confirmButtonText="languages.confirm"
      :confirmButtonColor="mainColor"
      @confirm="handleConfirm"
      @close="handleConfirm"
      :closeOnClickOverlay="true"
    >
      <div class="tip-wrap">
        <template v-if="orderId">
          <p>{{ languages.formCheckMsg1 }}</p>
          <p
            v-html="languages.formCheckMsg2"
            @click="handleJumpOrderDetail"
          ></p>
        </template>
        <p v-else class="text-center">{{ tip }}</p>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import TempSelect from '@components/officialSupport/workTemp/TempSelect.vue';
import TempInput from '@components/officialSupport/workTemp/TempInput.vue';
import TempSwitch from '@components/officialSupport/workTemp/TempSwitch.vue';
import TempDateTimePicker from '@components/officialSupport/workTemp/TempDateTimePicker.vue';
import TempUpload from '@components/officialSupport/workTemp/TempUpload.vue';
import TempOrder from '@components/officialSupport/workTemp/TempOrder.vue';
import TempAccountType from '@components/officialSupport/workTemp/TempAccountType.vue';
import TempServer from '@components/officialSupport/workTemp/TempServer.vue';
import { stepKey } from '@configs/officialSupport/accountDelete';
import { formType, fieldType } from '@configs/officialSupport/workTemp';
import { mapState } from 'vuex';
import accountDelete from '@mixins/officialSupport/accountDelete';
const channel = {
  google: 'Google Play',
  apple: 'App Store',
  other: 'Official Top-up'
};
export default {
  name: 'FormInput',
  mixins: [accountDelete],
  data() {
    return {
      tempId: null,
      tempName: null,
      tempType: null,
      formData: {},
      formList: [],
      compType: {
        [formType.input]: TempInput,
        [formType.select]: TempSelect,
        [formType.switch]: TempSwitch,
        [formType.date]: TempDateTimePicker,
        [formType.upload]: TempUpload,
        [fieldType.order]: TempOrder,
        [fieldType.accountType]: TempAccountType,
        [fieldType.server]: TempServer
      },
      compKey: stepKey.formInput,
      showTip: false,
      tip: '',
      orderId: ''
    };
  },
  computed: {
    ...mapState({
      languages: state => state.languages
    }),
    channelCustomKey() {
      return {
        defaultValue: '',
        options: [
          {
            label: this.languages.appleOption,
            value: 'apple'
          },
          {
            label: this.languages.googleOption,
            value: 'google'
          },

          {
            label: this.languages.otherOption,
            value: 'other'
          }
        ]
      };
    }
  },
  created() {
    this.initFormData();
  },
  watch: {
    isSumPay(val) {
      console.log('isSumPay', val);
      this.initFormData();
    }
  },
  methods: {
    async initFormData() {
      let initList = [
        {
          id: 'registrationDate',
          type: 'regTime',
          label: this.languages.delRegisterTime,
          formType: 'date',
          required: true,
          autoCheck: true,
          customKey: {
            type: 'year-month',
            uploadType: []
          },
          labelInfo: {
            label: this.languages.delRegisterTime,
            tip: '',
            required: true,
            tipImg: []
          },
          isCustomComp: false
        },
        {
          id: 'phoneModel',
          type: 'device',
          label: this.languages.delDevice,
          formType: 'input',
          required: true,
          customKey: {
            type: '',
            uploadType: []
          },
          labelInfo: {
            label: this.languages.delDevice,
            tip: '',
            required: true,
            tipImg: []
          },
          isCustomComp: false
        },
        {
          id: 'ipList',
          type: 'customer',
          label: this.languages.delIp,
          formType: 'input',
          required: false,
          customKey: {
            type: '',
            uploadType: []
          },
          labelInfo: {
            label: this.languages.delIp,
            tip: '',
            required: false,
            tipImg: []
          },
          isCustomComp: false
        },
        {
          id: 'deleteReason',
          type: 'customer',
          label: this.languages.delDeleteReason,
          formType: 'input',
          required: true,
          customKey: {
            type: '',
            uploadType: []
          },
          labelInfo: {
            label: this.languages.delDeleteReason,
            tip: '',
            required: true,
            tipImg: []
          },
          isCustomComp: false
        }
      ];
      if (this.isSumPay) {
        initList.splice(
          initList.length - 1,
          0,
          {
            id: 'payWay',
            type: 'customer',
            label: this.languages.delHistoryPayChannel,
            formType: 'select',
            required: true,
            customKey: this.channelCustomKey,
            labelInfo: {
              label: this.languages.delHistoryPayChannel,
              tip: '',
              required: true,
              tipImg: []
            },
            isCustomComp: false
          },
          {
            id: 'payOrderId',
            type: 'customer',
            label: this.languages.delHistoryPayOrder,
            formType: 'input',
            required: true,
            customKey: {
              type: '',
              uploadType: []
            },
            labelInfo: {
              label: this.languages.delHistoryPayOrder,
              tip: '',
              required: true,
              tipImg: []
            },
            isCustomComp: false
          }
        );
      }
      this.formList = initList;
      this.formList.forEach(item => {
        const isCustomComp = [
          fieldType.order,
          fieldType.accountType,
          fieldType.server
        ].includes(item.type);
        this.$set(this.formData, item.id, isCustomComp ? {} : null);
      });
    },
    getSubmitParams() {
      const newFormData = {};
      Object.keys(this.formData).forEach(item => {
        const newKey = item.replace(/([A-Z])/g, '_$1').toLowerCase();
        newFormData[newKey] = this.formData[item];
      });
      return newFormData;
    },
    async beforeSubmit(_values) {
      // clickButton({
      //   btnName: 'clickSubmitSmartOrder',
      //   locationKey: locationType.smartOrderPage,
      //   otherParams: {
      //     frontVersion: `v1_${new Date().getTime()}`,
      //     isOpenAiEntrance: this.isJumpAiBot,
      //     isLogin: this.isLogin
      //   }
      // });
      await this.$refs.formRef.validate();
      await this.submit();
    },
    async submit() {
      this.setOverlayVisible(true);
      this.resetFailFieldTip();
      const res = await this.submitAiOrder({
        ...this.getSubmitCommonParams(),
        is_check_info: true,
        is_act_delete: false,
        is_kr_player: this.submitForm.isKr,
        is_us_player: this.submitForm.isUs,
        is_ios_check_mode: this.isIosReview || false,
        ...this.getSubmitParams()
      });
      this.setOverlayVisible(false);
      if (res?.result === 1) {
        const errField = res?.data?.errField || '';
        if (
          [
            'ip_list',
            'registration_date',
            'phone_model',
            'delete_reason',
            'pay_way',
            'pay_order_id',
            'email'
          ].includes(errField)
        ) {
          const errorForm = {
            ip_list: 'ipList',
            registration_date: 'registrationDate',
            phone_model: 'phoneModel',
            delete_reason: 'deleteReason',
            pay_way: 'payWay',
            pay_order_id: 'payOrderId'
          };
          this.setFailFieldTip(errorForm[errField], this.languages.itemWrong);
          return;
        }
        if (res?.data?.orderId) {
          this.orderId = res?.data?.orderId;
          this.showTip = true;
          return;
        }
        this.updateSubmitForm(this.formData);
        this.nextStep();
      } else {
        this.tip = res?.data?.msg || '';
        this.showTip = true;
      }
    },
    setFailFieldTip(compkey, tip) {
      const field = document.querySelector(`[compkey="${compkey}"]`);
      const fieldParentEle = field.querySelector('.van-cell__value--alone');
      const fieldEle = document.createElement('div');
      fieldEle.className = 'van-field__error-message';
      fieldEle.innerText = tip;
      fieldParentEle.appendChild(fieldEle);
      field.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    },
    handleConfirm() {
      if (this.orderId) {
        this.jumpOrderList();
        return;
      }
      this.showTip = false;
    },
    handleJumpOrderDetail(e) {
      if (e.target.tagName === 'SPAN') {
        e.stopPropagation();
        this.jumpOrderDetail(this.orderId);
      }
    },
    resetFailFieldTip() {
      const errorField = document.querySelector('.van-field__error-message');
      if (errorField) {
        errorField.remove();
      }
    }
  },
  components: {
    TempSelect,
    TempInput,
    TempSwitch,
    TempDateTimePicker,
    TempUpload,
    TempOrder,
    TempAccountType,
    TempServer
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialSupport/workTempForm.scss';
@import '@assets/scss/officialSupport/accountDelete.scss';
.form-item-submit .btn {
  border-radius: 6px;
  height: 50px;
}
</style>
<style lang="scss">
.account-delete-link {
  color: #1989fa;
}
</style>
